module.exports = __webpack_public_path__ + "static/white-and-orange-text-ea405c89bfc86f6341b4ba865c9b6453.png";